import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import ContactUs from '../ContactUs'

export default function LayoutContactUs() {
    return (
        <>
            <Header />
            <ContactUs />
            <Footer />
        </>
    )
}
